import { render, staticRenderFns } from "./NewsReadersVisor.vue?vue&type=template&id=0c503928"
import script from "./NewsReadersVisor.vue?vue&type=script&lang=js"
export * from "./NewsReadersVisor.vue?vue&type=script&lang=js"
import style0 from "./NewsReadersVisor.vue?vue&type=style&index=0&id=0c503928&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports